<template>
  <div>
    <div class="summary">
      <pageTabHeader>
        <h5>Bulk {{ type === "bulkEdit" ? "Edit" : "Delete" }} Summary</h5>
      </pageTabHeader>
      <div class="content-wrapper">
        <div class="content">
          <h4>Summary</h4>
          <environmentSaveWarning />
          <div class="clients">
            <h6>Changes For:</h6>
            <v-chip-group v-for="id in bulkUpdateIds" :key="id">
              <tag close @click:close="removeBulkUpdateId(id)">{{ id }}</tag>
            </v-chip-group>
          </div>
          <commitData
            @setIsFormValid="setIsFormValid"
            @setTitle="setTitle"
            @setDetails="setDetails"
          />
          <updatedValuesSummary
            :clientInfoRuleId="type"
            :showAnswer="type === 'bulkEdit'"
            showEdit
            @edit="edit"
          />
        </div>
      </div>
    </div>
    <bottomBar>
      <qvoButton text @click="exitBulkSettings">Cancel</qvoButton>
      <qvoButton @click="showSaveConfirmation" :disabled="!isFormValid"
        >Confirm Commit</qvoButton
      >
    </bottomBar>
    <confirmationModal
      :value="isSaveConfirmationDisplayed"
      title="Are you sure?"
      @closeModal="cancelConfirmation"
    >
      <p class="subtitle-1">
        Are you sure you want to make these bulk
        {{ type === "bulkEdit" ? "edit" : "delete" }}s?
      </p>
      <template #buttons>
        <qvoButton text @click="cancelConfirmation">Cancel</qvoButton>
        <qvoButton @click="saveChanges">Yes, Confirm</qvoButton>
      </template>
    </confirmationModal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import bottomBar from "@/components/bottom-bar";
import confirmationModal from "@/components/confirmation-modal";
import environmentSaveWarning from "@/components/environment-save-warning";
import pageTabHeader from "@/components/page-tab-header";
import tag from "@/qux-common/qux22/components/molecules/tag";
import qvoButton from "@/qux-common/qux22/components/molecules/button";

import commitData from "@/components/commit-data";
import updatedValuesSummary from "@/components/updated-values-summary";

export default {
  components: {
    bottomBar,
    commitData,
    environmentSaveWarning,
    confirmationModal,
    updatedValuesSummary,
    pageTabHeader,
    tag,
    qvoButton,
  },
  data() {
    return {
      isSaveConfirmationDisplayed: false,
      isFormValid: false,
      details: undefined,
      title: undefined,
    };
  },
  methods: {
    removeBulkUpdateId(id) {
      this.$store.dispatch("removeBulkUpdateId", {
        ClientId: id,
      });
    },
    showSaveConfirmation() {
      this.isSaveConfirmationDisplayed = true;
    },
    cancelConfirmation() {
      this.isSaveConfirmationDisplayed = false;
    },
    edit({ questionId, tabId }) {
      this.$router.push(`/clients/${this.type}/${tabId}#${questionId}`);
    },
    setIsFormValid(value) {
      this.isFormValid = value;
    },
    setTitle(title) {
      this.title = title;
    },
    setDetails(details) {
      this.details = details;
    },
    saveChanges() {
      // ClientInfoRuleId in this case is used for pulling the config from the Vuex store
      this.$store.dispatch("saveConfig", {
        ClientIdList: this.bulkUpdateIds,
        ClientInfoRuleId:
          this.bulkUpdateMode === "edit" ? "bulkEdit" : "bulkDelete",
        ChangeTitle: this.title,
        ChangeDetails: this.details,
        ArrayMergeOption: this.bulkUpdateMode === "edit" && "concatMerge"
      });
      this.isSaveConfirmationDisplayed = false;
      this.exitBulkSettings();
    },
    exitBulkSettings() {
      this.$store.dispatch("resetBulkSettings");
      this.$router.push("/clients");
    },
  },
  computed: {
    type() {
      return this.$route.params.type;
    },
    ...mapGetters({
      bulkUpdateIds: "getBulkUpdateIds",
      bulkUpdateMode: "getBulkUpdateMode",
    }),
  },
};
</script>

<style lang="scss" scoped>
.page-tab-header {
  flex-direction: column;
}
.summary {
  $subheader-height: 80px;
  height: calc(100vh - $header-height - $subheader-height);
}
.content-wrapper {
  height: calc(100% - 74px);
  overflow: auto;
}
.content {
  padding: $qvo-spacing-24;
  max-width: 960px;
  margin: auto;
}
.clients {
  margin-top: $qvo-spacing-48;
  border: 2px solid $qvo-color-blue-400;
  border-radius: 8px;
  padding: $qvo-spacing-24;
}
.commit-data {
  margin-top: $qvo-spacing-24;
}
.bottom-bar {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 1;
}
</style>